/**
 * @generated SignedSource<<03213ce7419f3e18cdae17726d511a39>>
 * @relayHash 3a0689fdfe7df49daed3999acf5a0a6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d08a72bde7e26066a605d37df203412355af33f59460e03fabb5048368081ed

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueHistory_RefetchQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  isJiraAiAgentAvatarIssueViewHistoryEnabled: boolean;
  last?: number | null | undefined;
  orderBy?: string | null | undefined;
};
export type IssueHistory_RefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueHistoryFragment">;
  } | null | undefined;
};
export type IssueHistory_RefetchQuery = {
  response: IssueHistory_RefetchQuery$data;
  variables: IssueHistory_RefetchQuery$variables;
};
({
  "isJiraAiAgentAvatarIssueViewHistoryEnabled": isJiraAiAgentAvatarIssueViewHistoryEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider": isJiraAiAgentAvatarIssueViewHistoryEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider: {
    readonly get: () => boolean;
  };
  readonly isJiraAiAgentAvatarIssueViewHistoryEnabled: {
    readonly get: () => boolean;
  };
});

import isJiraAiAgentAvatarIssueViewHistoryEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-issue-view-history.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraAiAgentAvatarIssueViewHistoryEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "formattedValue"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayValue"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = {
  "kind": "ScalarField",
  "name": "avatarUrl"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    }
  ],
  "type": "AppUser"
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = [
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "categoryId"
      },
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "type": "JiraHistoryStatusFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "concreteType": "JiraWorklog",
        "kind": "LinkedField",
        "name": "worklog",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "worklogId"
          },
          {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timeInSeconds"
              }
            ]
          },
          {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "workDescription",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "json"
                  },
                  {
                    "concreteType": "JiraAdfToConvertedPlainText",
                    "kind": "LinkedField",
                    "name": "convertedPlainText",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "plainText"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraHistoryWorkLogFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v13/*: any*/),
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v16/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "JiraHistoryAssigneeFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v14/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "absoluteIconUrl"
      }
    ],
    "type": "JiraHistoryPriorityFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "concreteType": "JiraHistoryResponder",
        "kind": "LinkedField",
        "name": "responders",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          (v17/*: any*/),
          (v11/*: any*/),
          (v15/*: any*/)
        ]
      }
    ],
    "type": "JiraHistoryRespondersFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "type": "JiraHistoryGenericFieldValue"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueHistory_RefetchQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "IssueHistoryFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueHistory_RefetchQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraIssueHistoryConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraHistoryActivityFeedItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "i18nDescription"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldDisplayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "timestamp"
                          },
                          {
                            "concreteType": "JiraHistoryFieldSchema",
                            "kind": "LinkedField",
                            "name": "fieldSchema",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "customFieldType"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedaction"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedactionRestore"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  (v16/*: any*/)
                                ]
                              },
                              (v9/*: any*/)
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v10/*: any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "IssueHistory_history",
                "kind": "LinkedHandle",
                "name": "history"
              }
            ],
            "type": "JiraIssue"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0d08a72bde7e26066a605d37df203412355af33f59460e03fabb5048368081ed",
    "metadata": {},
    "name": "IssueHistory_RefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "isJiraAiAgentAvatarIssueViewHistoryEnabled": isJiraAiAgentAvatarIssueViewHistoryEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarissueviewhistoryrelayprovider": isJiraAiAgentAvatarIssueViewHistoryEnabled_provider
    }
  }
};
})();

(node as any).hash = "7904d2d271933590ffe6912d24e43036";

export default node;
